import React, { useEffect, useRef, useState } from "react";

const EndToEndProcessFlowSection = () => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="process-flow-section py-5" ref={sectionRef}>
      <div className="container text-center">
        <h2 className="fw-bold text-dark mb-4">End-to-End Process Flow</h2>
        <div className={`process-image-wrapper ${isVisible ? "zoom-in" : ""}`}>
          <img
            src="/assets/images/ProcessFlow.png"
            alt="End-to-End Process Flow"
            className="img-fluid"
          />
        </div>
      </div>
    </section>
  );
};

export default EndToEndProcessFlowSection;
